import { createSelector } from 'reselect'

export const selectPodUpdaterState = state => state.podUpdaterTools

export const selectPodUpdaterMode = createSelector(
  selectPodUpdaterState,
  data => data.mode
)

export const selectPodUpdaterProviderUuid = createSelector(
  selectPodUpdaterState,
  data => data.providerUuid
)

export const selectPodUpdaterPodsText = createSelector(
  selectPodUpdaterState,
  data => data.podsText
)

export const selectPodUpdaterStoreData = createSelector(
  selectPodUpdaterState,
  data => ({
    mode: data.mode,
    providerUuid: data.providerUuid,
    podsText: data.podsText,
    isSubmitting: data.isSubmitting,
    resultError: data.resultError,
    resultMessage: data.resultMessage,
    providers: data.providers || [],
    isProvidersLoading: Boolean(data.isProvidersLoading),
    providersError: data.providersError,
    businessType: data.businessType,
    country: data.country,
  })
)
